import * as types from './actionTypes';

export function setLoading(loading) {
  return {
    type: types.LOADING,
    loading,
  };
}